// import React, { useEffect, useRef, useState } from "react";
// import { withSnackbar } from "notistack";
// // Data Tables
// import jQuery from "jquery";
// import "datatables.net-bs4";
// import "datatables.net-buttons-bs4";
// import "datatables.net-buttons/js/buttons.html5";
// import "datatables.net-buttons/js/buttons.print";
// import "datatables.net-buttons/js/buttons.flash";
// import "pdfmake/build/pdfmake";
// import "pdfmake/build/vfs_fonts";

// import Loader from "components/Custom/Loader";
// import AutoComplete from "components/Custom/AutoComplete";
// import TxtBox from "components/Custom/TxtBox";
// import Btn from "components/Custom/Btn";

// import { NOTIFY } from "common/config";
// import { LABELS, WARNINGS } from "common/lables";

// import { DateFunctions } from "common/datefunctions";
// import { COMMON_JS } from "common/scripts";
// import { REPORTS_APIs } from "apihandlers/reports";

// const $ = jQuery;

// const RouteList = (props: any) => {
//   const [loading, setLoading] = useState(false);
//   const [chartData, setChartData] = useState<any>({});

//   const generateReportGrid = (res: any) => {
//     let title = LABELS.ROUTE_LIST_REPORT;
//     if (projectRef.current) {
//       title += " - " + projectRef.current.selectedValue.label;
//     }
//     $("#reportGrid").DataTable({
//       dom: "Bfrtip",
//       buttons: [
//         {
//           extend: "csv",
//           className: "reportBtn",
//           title: title,
//           text: "<i class='fa fa-download'></i>",
//         },
//       ],
//       paging: true,
//       pageLength: 15,
//       columns: res.cols,
//       data: res.rows,
//       order: [],
//     });
//   };

//   const loadChart = () => {
//     const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
//       .value;
//     const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
//     const args = {
//       fromDt,
//       toDt,
//     };
//     if ($.fn.dataTable.isDataTable("#reportGrid")) {
//       let table = $("#reportGrid").DataTable();
//       table.destroy();
//     }
//     if ($("#reportGrid")) {
//       $("#reportGrid").empty();
//     }
//     setChartData(null);
//     REPORTS_APIs.getRouteReport(args).then((res) => {
//       // console.log("getUserLogReport:", args);
//       const response: any = res.response;
//       const { status } = res;
//       if (status === 200) {
//         setChartData(response);
//         setTimeout(() => {
//           generateReportGrid(response);
//         }, 500);
//       }
//     });
//   };

//   const projectRef: any = useRef();

//   return (
//     <React.Fragment>
//       <div className="pageInfo">
//         <ul className="breadcrumbs">
//           <li>{LABELS.HOME}</li>
//           <li className="dim">{" / "}</li>
//           <li onClick={() => props.setDashMenu(LABELS.HOME)}>
//             {LABELS.DASHBOARD}
//           </li>
//           <li className="dim">{" / "}</li>
//           <li className="active">{LABELS.ROUTE_LIST_REPORT}</li>
//         </ul>
//         <h4>{LABELS.ROUTE_LIST_REPORT}</h4>
//       </div>
//       {loading ? (
//         <div className="flexCenter" style={{ minHeight: 450 }}>
//           <Loader />
//         </div>
//       ) : (
//         <div className="hChart">
//           <div id="chartForm">
//             <div
//               className="formGroup"
//               style={{
//                 display: "flex",
//                 marginTop: 5,
//                 marginBottom: 20,
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   marginRight: 15,
//                   justifyContent: "center",
//                   alignItems: "center",
//                 }}
//               >
//                 <label
//                   style={{
//                     fontWeight: "500",
//                     fontSize: 14,
//                     marginTop: 6,
//                     marginRight: 8,
//                   }}
//                 >
//                   {LABELS.FROM_DATE}
//                 </label>
//                 <TxtBox
//                   type={"date"}
//                   id="fromDt"
//                   defaultValue={DateFunctions.getDate(
//                     "today",
//                     "from",
//                     "YYYY-MM-DD"
//                   )}
//                 />
//               </div>

//               <div
//                 style={{
//                   display: "flex",
//                   marginRight: 15,
//                   justifyContent: "center",
//                   alignItems: "center",
//                 }}
//               >
//                 <label
//                   style={{
//                     fontWeight: "500",
//                     fontSize: 14,
//                     marginTop: 6,
//                     marginRight: 8,
//                   }}
//                 >
//                   {LABELS.TO_DATE}
//                 </label>
//                 <TxtBox
//                   type={"date"}
//                   id="toDt"
//                   defaultValue={DateFunctions.getDate(
//                     "thismonth",
//                     "to",
//                     "YYYY-MM-DD"
//                   )}
//                 />
//               </div>

//               <div
//                 style={{
//                   display: "flex",
//                 }}
//               >
//                 <Btn
//                   text={LABELS.LOAD}
//                   onClick={loadChart}
//                   loading={!chartData}
//                 />
//               </div>
//             </div>
//           </div>

//           {chartData ? (
//             <div className="reportGridWrapper">
//               <table
//                 id="reportGrid"
//                 className="mdl-data-table width100"
//                 cellSpacing="0"
//                 cellPadding="3"
//               />
//             </div>
//           ) : (
//             <div
//               className="flexCenter"
//               style={{ minHeight: 400, width: "100%" }}
//             >
//               <Loader />
//             </div>
//           )}
//         </div>
//       )}
//     </React.Fragment>
//   );
// };

// export default withSnackbar(RouteList);

import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import { NOTIFY } from "common/config";
import { LABELS, WARNINGS, TITLES, SUB_TITLES } from "common/lables";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";

import { MASTER_APIs } from "apihandlers/master";
import { REPORTS_APIs } from "apihandlers/reports";
import { COLORS } from "common/colors";

const RouteList = (props: any) => {
  const { setDashMenu } = props;

  const outletRef: any = useRef();

  const [loading, setLoading] = useState(true);
  const [masters, setMasters] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "billNumber",
      name: LABELS.BILL_NUMBER,
      width: "30%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },

    {
      key: "time",
      name: LABELS.TIME,
      width: "30%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "total",
      name: LABELS.TOTAL,
      width: "30%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
  ];

  useEffect(() => {
    if (loading) {
      getOrgProfile();
    }
  }, [loading]);

  const getOrgProfile = () => {
    const args = {
      minResponse: true,
    };
    MASTER_APIs.getPosCenters(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list: any = [{ id: -1, label: "All" }];
        let recs: any = response.records;
        for (let i = 0; i < recs.length; i++) {
          list.push({
            id: recs[i].idcenters,
            label: recs[i].name,
          });
        }
        setMasters(list);
        // setLoading(false);
      }
    });
  };

  const loadChart = () => {
    const outlet = outletRef.current.selectedValue.id;
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    const args = {
      inTime: fromDt,
      outTime: toDt,
      outlet,
      reportType: "excel",
    };
    let errors = [];
    if (!outlet) {
      errors.push({
        id: "outlet",
        msg:
          "<span class='bold'>" +
          LABELS.OUTLET +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (fromDt === "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    setRows(null);
    // setLoading(true);
    REPORTS_APIs.getPosBillRegister(args).then((res) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
        }
        setRows(response.rows);
        setLoading(false);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    loadChart();
  };

  console.log("Page: BillRegister:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.ROUTE_LIST_REPORT}</li>
        </ul>
        <h4>{TITLES.ROUTE_LIST_REPORT}</h4>
        <p>{SUB_TITLES.ROUTE_LIST_REPORT}</p>
      </div>
      <div className="hChart">
        <div
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
        >
          {/* <div
            className="formGroup"
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: 5,
              marginBottom: 10,
              width: "40%",
            }}
          >
            <label>{LABELS.SELECT_OUTLET + " :"}</label>
            <AutoComplete
              id={"masters"}
              list={masters}
              childRef={outletRef}
              defaultValue={{ id: -1, label: "All" }}
            />
          </div> */}
          <div
            className="formGroup"
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: 0,
              marginBottom: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                marginRight: 15,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  fontWeight: "500",
                  fontSize: 14,
                  marginTop: 6,
                  marginRight: 8,
                }}
              >
                {LABELS.FROM_DATE}
              </label>
              <TxtBox
                type={"date"}
                id="fromDt"
                defaultValue={DateFunctions.getDate(
                  "today",
                  "from",
                  "YYYY-MM-DD"
                )}
              />
            </div>

            <div
              style={{
                display: "flex",
                marginRight: 15,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  fontWeight: "500",
                  fontSize: 14,
                  marginTop: 6,
                  marginRight: 8,
                }}
              >
                {LABELS.TO_DATE}
              </label>
              <TxtBox
                type={"date"}
                id="toDt"
                defaultValue={DateFunctions.getDate(
                  "thismonth",
                  "to",
                  "YYYY-MM-DD"
                )}
              />
            </div>

            <div
              style={{
                display: "flex",
                padding: 10,
                marginTop: "0.3rem",
              }}
            >
              <Btn
                text={LABELS.LOAD}
                onClick={loadChart}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </div>
        {mandatoryResults.length > 0 && (
          <div className="mandatoryBox">
            <ul>
              {mandatoryResults.map((m) => {
                return (
                  <li>
                    <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        <div className="grid excelGridWrapper">
          {!loading &&
            (rows ? (
              <ExcelGrid
                id={"routeListReport"}
                height={window.innerHeight * 0.7}
                cols={columns}
                rows={rows}
                exportOption={true}
                newRowOption={false}
                exportName={LABELS.ROUTE_LIST_REPORT}
                onReload={reloadGrid}
              />
            ) : (
              <div className="flexCenter" style={{ minHeight: 450 }}>
                <Loader />
              </div>
            ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(RouteList);
